import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M172.309-140.001q-30.308 0-51.308-21t-21-51.308v-535.382q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v535.382q0 30.308-21 51.308t-51.308 21H172.309zm0-59.999h615.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-535.382q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H172.309q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v535.382q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846zm37.692-90.001h179.998v-59.998H210.001v59.998zM582-374.232L765.768-558 723-600.768l-141 142-57-57L483.232-473 582-374.232zm-371.999-75.769h179.998v-59.998H210.001v59.998zm0-160h179.998v-59.998H210.001v59.998zM160-200v-560 560z"
      ></path>
    </svg>
  );
}

export default Icon;
